<template>
  <div class="row">
    <load v-if="loading" message="Carregando os Encaminhamentos do Acolhimento" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div v-if="!novo_encaminhamento" class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col">
                      <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between">
                        <h4 class="font-weight-bold">Encaminhamentos</h4>
                      </div>
                    </div>
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_encaminhamento = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div>
                          <div>
                            <b-button-group>
                              <b-button
                                variant="outline-dark"
                                :class="
                                  viewFilterReport === true ? 'active' : ''
                                "
                                @click="viewFilters"
                              >
                                <i class="fas fa-filter"></i>
                                {{ $t("Filtros") }}
                              </b-button>
                              <b-button variant="outline-dark" @click="print()">
                                <i class="fas fa-print"></i>
                              </b-button>
                              <b-button
                                variant="outline-dark"
                                @click="exportar()"
                                :title="$t('Exportar')"
                                v-b-tooltip.hover
                              >
                                <i class="fas fa-file-excel"></i>
                              </b-button>
                            </b-button-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" v-if="viewFilterReport">
                      <form
                        @submit.prevent="getEncaminhamentos"
                        ref="formFiltros"
                      >
                        <div class="row">
                          <form-calendar
                            v-model="data_inicio"
                            grid="4"
                            label="Data Inicial"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="4"
                            label="Data Final"
                            :required="verificaDataInicial"
                          />

                          <form-select
                            v-model="filtroStatus"
                            label="Status"
                            :itens="status"
                            grid="4"
                          />
                        </div>
                        <div
                          class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default btn-sm"
                              @click.prevent="
                                limparFiltros();
                                viewFilterReport = false;
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary btn-sm"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit btn-sm"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <load mode="table" v-if="loadingEncaminhamentos" />
                    <div class="col-12" v-else>
                      <span>
                        <a
                          v-if="!showName"
                          @click.prevent="mostrarNome"
                          href="#"
                          ><i class="fas fa-eye"></i> Mostrar Nome de
                          Registro</a
                        >
                        <a v-else @click.prevent="ocultarNome" href="#"
                          ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                          Registro</a
                        >
                      </span>
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'protocolo',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'created_at',
                              label: $t('Data'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="EncaminhamentosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            <i
                              class="mdi mdi-lock mdi-18px text-danger"
                              v-if="data.item.privado == 1"
                              v-b-popover.hover.top="
                                'Encaminhamento com sigilo'
                              "
                            ></i>
                            Usuário(s):<br />
                            <ul>
                              <li v-for="pessoa in data.item.usuarios" :key="pessoa.id">
                                <b>
                                  <!-- Exibe nome social se houver -->
                                  {{ pessoa.nome_acolhido || pessoa.nome  }}
                                </b>

                                <!-- Exibe o tipo de parentesco -->
                                <span v-if="pessoa.parentesco">
                                  - <i>{{ pessoa.parentesco }}</i>
                                </span>

                                <span v-else-if="pessoa.tipo_cadastro">
                                  - <i>{{ pessoa.tipo_cadastro }}</i>
                                </span>
                                
                                <span v-else>
                                  - <i> Acolhido principal </i>
                                </span>

                              </li>
                            </ul>
                            Protocolo:
                            <b>{{ data.item.protocolo }}</b>
                            <br />
                            Tipo: <b>{{ data.item.tipo.descricao }}</b>
                            <br />
                            Origem:
                            <b v-if="data.item.unidade">{{
                              data.item.unidade.nome
                            }}</b>
                            <br />
                            Técnico
                            <b>{{ data.item.tecnico.nome }}</b> -
                            <span>
                              {{
                                data.item.tecnico.profissao ?? "Não informado"
                              }}
                            </span>

                            <span v-if="data.item.unidade_destino">
                              <br />
                              Unidade de Destino:
                              <b>{{ data.item.unidade_destino.nome }}</b>
                            </span>
                            <span
                              v-if="data.item.unidade_externa"
                              class="text-muted text-xs"
                            >
                              - Unidade Externa
                            </span>
                            <span v-if="data.item.tecnico_destino">
                              <br />
                              Técnico de Destinatário:
                              <b>{{ data.item.tecnico_destino.nome }}</b> -
                              <span>
                                {{
                                  data.item.tecnico_destino.profissao ??
                                  "Não informado"
                                }}
                              </span>
                            </span>
                          </template>
                          <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | formatDate() }}
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              v-if="user_id == data.item.user_id"
                              @click="redirectEncaminhamento(data.item.id)"
                              class="px-2 mb-0 btn btn-sm btn-success"
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>

                            <b-button
                              v-if="
                                (unidade_id == data.item.unidade_id ||
                                  unidade_id == data.item.unidade_destino_id) &&
                                (data.item.user_role ==
                                  'Técnico(a) Administrativo(a)' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSB' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSE' ||
                                  $store.state.user.role_details.name ==
                                    'Coordenador' ||
                                  $store.state.user.role_details.name ==
                                    'Gestor(a)' ||
                                  $store.state.user.role_details.name ==
                                    'Técnico(a) de Nível Superior')
                              "
                              :title="$t('Visualizar e Imprimir')"
                              :to="
                                '/dashboard/encaminhamentos/show/' +
                                data.item.id
                              "
                              class="px-2 mb-0"
                              size="sm"
                              type="button"
                              v-b-tooltip.hover
                              variant="primary"
                            >
                              <i class="mdi mdi-eye" />
                            </b-button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getEncaminhamentos"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoEncaminhamento v-else :acolhimento="item" @voltar="novo_encaminhamento = false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NovoEncaminhamento from "./AddEncaminhamento";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  components: { NovoEncaminhamento },
  name: "Encaminhamentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Encaminhamentos"),
    };
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      loadingEncaminhamentos: false,
      encaminhamentos_recebidos: 1,
      filtroStatus: null,
      filtroFamiliar: null,
      data_inicio: null,
      data_fim: null,
      status: [],
      familiares: [],
      EncaminhamentosList: [],
      pagination: {},
      showName: false,
      user_id: this.$store.state.user.id,
      unidade_id: this.$store.state.user.unidade_id,
      novo_encaminhamento: false,
      search: "",
      isLoadingMsg: false,
      loading: false,
    };
  },
  mounted() {
    this.getStatus();
    this.getEncaminhamentos();
  },
  watch: {
    encaminhamentos_recebidos() {
      this.page = 1; // reset page on filter change
      this.getEncaminhamentos();
    },
    item: {
      immediate: true,
      handler() {
        this.page = 1;
        this.getEncaminhamentos();
      },
    },
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getEncaminhamentos() {
      this.loadingEncaminhamentos = true;

      const filtroDatas = [];
      if (this.data_inicio) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_inicio));
      if (this.data_fim) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_fim));

      axios.get("api/dashboard/encaminhamentos", {
        params: {
          acolhimento_idosos_id: this.item.id,
          page: this.page,
          perPage: this.perPage,
          encaminhamentos_recebidos: this.encaminhamentos_recebidos,
          filtroStatus: this.filtroStatus,
          filtroDatas,
          filtroFamiliar: this.filtroFamiliar,
          search: this.search,
        },
      })
      .then(response => {
        this.EncaminhamentosList = response.data.data;
        this.pagination = response.data.pagination;

        if (this.pagination.totalPages && this.pagination.totalPages < this.page) {
          this.page = this.pagination.totalPages;
          this.getEncaminhamentos();
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loadingEncaminhamentos = false;
      });
    },

    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;

      const filtroDatas = [];
      if (this.data_inicio) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_inicio));
      if (this.data_fim) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_fim));

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo da quantidade de registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });

      axios.get("api/dashboard/encaminhamentos", {
        params: {
          acolhimento_idosos_id: this.item.id,
          page: this.page,
          perPage: this.perPage,
          filtroStatus: this.filtroStatus,
          filtroDatas,
          filtroFamiliar: this.filtroFamiliar,
          search: this.search,
          export: "ok",
        },
      })
      .then((response) => {
        this.isLoadingMsg = false;
        this.loading = false;

        swal.fire({
          title: "Arquivo Pronto para Download!",
          html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
          icon: "success",
          showConfirmButton: false,
        });
      })
      .finally(() => {
        this.isLoadingMsg = false;
        this.loading = false;
      });
    },

    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getEncaminhamentos();
      }
    },

    redirectEncaminhamento(id) {
      this.$router.push({
        path: `/dashboard/encaminhamentos/edit/${id}`
      });
    },

    getStatus() {
      axios.get(`api/dashboard/status/encaminhamentos`).then((response) => {
        this.status = response.data;
      });
    },

    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.data_inicio = null;
      this.data_fim = null;
      this.filtroFamiliar = null;
      this.page = 1;
      this.getEncaminhamentos();
    },
  },
};
</script>